import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/user/root'

export const startRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/start',
    component: lazyRouteComponent(() => import('./Start'), 'Start'),
})
